import { useScroll } from 'motion/react';
import { useEffect, useRef } from 'react';

import { CAR_QUALITY_ANIMATION_HEIGHT, CAR_QUALITY_ANIMATION_WRAPPER_ID } from './carQualityAnimation.constants';

export const useCarQualityAnimationRef = () => {
  const carQualityAnimationRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (globalThis.window !== undefined) {
      const animationWrapper = document.getElementById(CAR_QUALITY_ANIMATION_WRAPPER_ID);
      if (animationWrapper) {
        carQualityAnimationRef.current = animationWrapper as HTMLDivElement;
      }
    }
  }, []);

  return carQualityAnimationRef;
};

export const useCarQualityAnimationScroll = () => {
  const scrollRef = useCarQualityAnimationRef();
  const scroll = useScroll({
    target: scrollRef,
    offset: [
      'start start',
      // Height of the car quality animation
      `${CAR_QUALITY_ANIMATION_HEIGHT}px end`,
    ],
  });

  return scroll;
};
